const menu = require('../../../../../../components/menu/menu')
const dtHandler = require('../../../../../../components/dt/dt-handler')


export function start(detail, htmlDt, htmlFc) {

  const menuElem = menuBody[detail.id]

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc)
  }

  detail.html = menuElem
  detail.act = 'show'
  menu.start(detail)

}

const menuBody = {

  fullcontOptions: [

    // {
    //   text: '',
    //   svg: 'edit',
    //   class: ``, //same name as the title test
    //   dataDetail: ``,

    //   start: function (detail, htmlDt, htmlFc) {
    //     this.text = `Lost`
    //     this.dataDetail = `data-detail='{
    //                                "click": [
    //                                   {"dest":"ripple" },
    //                                   {"dest":"menu", "act":"hide"},
    //                                   {"dest":"fullcont", "id":"purchase-fullcont2", "act":"NoTabSource", "pagetoshow":"lost" } ]}'`
    //   }/**/
    // },

    {
      text: '',
      svg: 'print',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        //if exist one check
        this.class = ``
        this.text = `Print Order`
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"accountsPayable", "elem":"purchaseFullcont2", "id":"purchase-fullcont2", "act":"purchasePrintPdf", "id":""} ]}'`
      }/**/
    },


    {
      text: '',
      svg: 'print',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        //if exist one check
        this.class = ``
        this.text = `Print Label`
        this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"accountsPayable", "elem":"purchaseFullcont2", "act":"printlabel"} ]}'`
      }/**/
    },


    // {
    //   text: '',
    //   svg: 'report',
    //   class: ``, //same name as the title test
    //   dataDetail: ``,

    //   start: function (detail, htmlDt, htmlFc) {

    //     //if exist one check
    //     this.class = ``
    //     this.text = `Purchase Report`
    //     this.dataDetail = `data-detail='{
    //                                  "click": [
    //                                     {"dest":"ripple" },
    //                                     {"dest":"menu", "act":"hide"},
    //                                     {"dest":"purchase", "elem":"report", "reportType":"reportOne", "source":"fullcont"} ]}'`
    //   }/**/
    // },

    // { text: 'line', start: function () { } }, //////////////line

    // {
    //   text: '',
    //   svg: 'delete',
    //   class: ``, //same name as the title test

    //   dataDetail: ``,

    //   start: function (detail, htmlDt, htmlFc) {

    //     const dbid = htmlFc.fullcontHTML.getAttribute('data-dbid')

    //     //if exist one check
    //     this.class = ``
    //     this.text = `Delete `
    //     this.dataDetail = `data-detail='{
    //                                 "click": [
    //                                     {"dest":"ripple" },
    //                                     {"dest":"menu", "act":"hide"},
    //                                     {"dest":"accountsPayable", "elem":"purchaseFullcont2", "act":"deleteEntity", "entity":"purchase",  "dbid":[${dbid}]} ]}'`

    //   }/**/
    // },

  ],

}/*menuBody*/


